import UserAvatarController from './user-avatar.controller';
import { UserAvatarProps } from './user-avatar.model';

const UserAvatar = (props: UserAvatarProps) => {
  return <UserAvatarController {...props} />;
};

export default UserAvatar;
